import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { BambooSecrets_ResponsivePIXIApp } from "../BambooSecrets/game_ResponsivePIXIApp";

export class BambooSecretsLink_ResponsivePIXIApp extends BambooSecrets_ResponsivePIXIApp {

        constructor(multigameParams: MultigameParams , initData: SlotGameInitData) {
            super(multigameParams , initData, "BambooSecretsLink");
        }
    }
     
